import { notices } from "../data/generated";
import { displayClock } from "../game/progression";
import type { GameState } from "../types";
import { ProgressIndicator } from "../components/ProgressIndicator";

interface PortalScreenProps {
  run: GameState;
  onOpenMailbox: () => void;
  onOpenDirectory: () => void;
  onOpenManual: () => void;
  onOpenSettings: () => void;
  onReturnTitle: () => void;
}

export function PortalScreen({ run, onOpenMailbox, onOpenDirectory, onOpenManual, onOpenSettings, onReturnTitle }: PortalScreenProps) {
  const mutatedNotice = run.portalMutationIds.includes("retired_notice");
  const shownNotices = mutatedNotice
    ? [{ id: "retired_notice", date: "2026-07-23", title: "管理部業務再開のお知らせ", body: "山田管理課長が本日付で復職しました。旧管理部宛ての連絡を再開してください。" }, ...notices]
    : notices;
  const userName = run.loopCount >= 6 ? "山田 修一" : "夜間監視担当";

  return (
    <main className="portal-screen app-surface">
      <header className="portal-header">
        <div>
          <div className="portal-logo">東央データ管理株式会社</div>
          <div className="portal-system-name">社内情報ポータル</div>
        </div>
        <div className="portal-user">
          <span>ログイン: {userName}</span>
          <strong>{displayClock(run)}</strong>
        </div>
      </header>

      <nav className="portal-nav">
        <button type="button" onClick={onOpenMailbox}>メールボックス</button>
        <button type="button" onClick={onOpenDirectory}>社員名簿</button>
        <button type="button" onClick={onOpenManual}>業務マニュアル</button>
        <button type="button" onClick={onOpenSettings}>設定</button>
        <button type="button" onClick={onReturnTitle}>ログアウト</button>
      </nav>

      <div className="portal-content">
        <section className="portal-main">
          <div className="section-heading"><h2>社内のお知らせ</h2><span>最終更新 2026/07/22</span></div>
          <div className="notice-list">
            {shownNotices.map((notice) => (
              <article key={notice.id} className={notice.id === "retired_notice" ? "notice-item is-corrupted" : "notice-item"}>
                <time>{notice.date.replaceAll("-", "/")}</time>
                <div><h3>{notice.title}</h3><p>{notice.body}</p></div>
              </article>
            ))}
          </div>
        </section>

        <aside className="portal-side">
          <ProgressIndicator progress={run.progress} required={run.requiredProgress} loopCount={run.loopCount} />
          <div className="portal-card">
            <h3>夜間監視業務</h3>
            <dl>
              <div><dt>担当</dt><dd>{userName}</dd></div>
              <div><dt>勤務時間</dt><dd>23:40–06:00</dd></div>
              <div><dt>端末</dt><dd>NW-07</dd></div>
              <div><dt>状態</dt><dd className="status-ok">監視中</dd></div>
            </dl>
            <button type="button" className="primary-button" onClick={onOpenMailbox}>受信箱を開く</button>
          </div>
          <div className="portal-card system-card">
            <h3>システム情報</h3>
            <p>メールゲートウェイ: 正常</p>
            <p>社員DB: {run.directoryMutationIds.length ? "更新済み" : "正常"}</p>
            <p>時刻同期: {run.loopCount ? "再同期中" : "正常"}</p>
          </div>
        </aside>
      </div>
    </main>
  );
}
